import Grid from "@mui/material/Grid/Grid";
import {
    // CustomLabelLargeBold,
    // CustomLabelLargeBoldIntro,
    CustomLabelLargeBoldIntroHead,
    // CustomLabelMediumRegular, CustomLabelMediumRegularInto,
    CustomLabelSmallRegular, CustomLabelRegularLargeMedium
} from "../common/CustomLabel";
import PEACE_HAND from "../../assets/images/peace-hand.png";
import ARROW_RIGHT from "../../assets/images/arrow-right-tag.png";
import {motion} from "framer-motion";
import Box from "@mui/material/Box/Box";
// import CIRCULAR_LOGO from "../../assets/images/circular-logo.png";
// import COMPUTER_LOGO from "../../assets/images/computer.png";
import OSTRYX_PROMO from "../../assets/videos/OstryxPromo1.mp4";
import React from "react";
import createTheme from "@mui/material/styles/createTheme";
import {useMediaQuery} from "@mui/material";
import PromoVideo from "../promo-video";
import {  
    // useTheme , 
    Button} from '@mui/material';

import { ThemeProvider } from '@mui/material';
// import BACKGROUND_IMAGE from "../../assets/images/BG.png";
import OSTRYX_LOGO from "../../assets/icons/OSTRYXNo.1Softwaredevelopmentcompany.webp";


const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 710,
            md: 950,
            lg:1200,
            xl: 1250
        },
    },
});


const Intro=({setShowWhatService})=>{


    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.up("sm"));


    return (
        <ThemeProvider theme={theme} >
        <Grid container
              sx={{
                marginTop: { xs: '30px', md: '40px' }, 
                padding: { xs: '0px 10px', md: '12px 80px' },
                // position: 'relative',
                // '&::before': {
                //     content: '""',
                //     position: 'absolute',
                //     top: 0,
                //     left: 0,
                //     right: 0,
                //     bottom: 0,
                //     backgroundImage: `url(${BACKGROUND_IMAGE})`,
                //     backgroundSize: 'cover',
                //     backgroundPosition: 'center',
                //     backgroundRepeat: 'no-repeat',
                //     zIndex: -1
                // }
            }}>
            <div>
                <Grid item xs={12} container justifyContent={{md:"space-between"}} sx={{height:"100%"}}>
                    <Grid item xs={12} md={5.5} container direction={{xs:"row",md:"column"}} alignItems={{xs:"center",md:"flex-start"}} justifyContent={{xs:"center",md:"space-between"}}
                          sx={{padding:{lg:"20px 0px"},height:{md:"100%"}}}>
                        <Grid item xs={10} md={"auto"} >
                            <CustomLabelLargeBoldIntroHead
                             fontWeight={700}  
                             text={<>Leading <span style={{color: "#5E17EB"}}> Mobile App Development </span> Company in USA</>}
                             >
                                {/* Turning Your Vision Into Reality With <span style={{color: "#5E17EB"}}>Top-Tier</span> Tech Solutions. */}
                                {/* Your Vision, Our Code – <span style={{color: "#5E17EB"}}>Next-Gen</span> Customized Digital Solutions. */}
                                {/* Leading Mobile App Development Company in USA */}
                                {/* Leading <span style={{color: "#5E17EB"}}> Mobile App Development </span> Company in USA */}
                            </CustomLabelLargeBoldIntroHead>
                        </Grid>

                        <Grid item xs={10} md={"auto"} sx={{marginTop:{xs:"30px",lg:"40px"}}}>
                            <CustomLabelRegularLargeMedium lineHeight={1.5}
                            fontWeight={400}    
                            textAlign={{xs:"center",md:"left"}}    
                            text={<>Looking for a reliable partner to turn your app idea into reality? OSTRYX is a 
                                {/* &nbsp;<a href="https://ostryx.com" target="_blank" rel="noopener noreferrer" style={{color: "#5E17EB"}}><b>Leading Mobile App Development Company in USA</b></a>,  */}
                                &nbsp; Leading Mobile App Development Company in USA 
                                specializing in Custom iOS and Android app development. Whether you're a startup or an enterprise, our Custom Mobile App Development Services are customized to meet your business goals with innovation, speed, and precision. With a proven track record of delivering high-performance, user-centric mobile apps, OSTRYX stands out as the top choice for mobile app development across the USA.</>}
                            />
                            <CustomLabelRegularLargeMedium lineHeight={1.5}
                            fontWeight={400}    
                            textAlign={{xs:"center",md:"left"}}    
                            text={<>Partner with OSTRYX - where great apps begin!.</>}
                            />
                        </Grid>

                        <Grid 
                            item 
                            container 
                            sx={{ 
                                mt: { xs: 5, lg: 6 },
                                justifyContent: { xs: 'center', md: 'flex-start' }
                            }}
                        >
                            <Button
                                onClick={() => setShowWhatService(true)}
                                sx={{
                                    width: {
                                        xs: '90%',
                                        md: '400px'
                                    },
                                    border: '1.5px solid #F5F5F5',
                                    borderRadius: '20px',
                                    padding: {
                                        xs: '12px 20px',
                                        md: '15px 25px'
                                    },
                                    background: '#5E17EB',
                                    '&:hover': {
                                        background: '#4912b9'
                                    },
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center',
                                    gap: { xs: 1, md: 2 }
                                }}>
                                    <Box
                                        component="img"
                                        src={PEACE_HAND}
                                        alt={"Peace Hand"}
                                        sx={{
                                            // width: { xs: '24px', md: '28px' },
                                            // height: { xs: '24px', md: '28px' },
                                        }}
                                    />
                                    <CustomLabelSmallRegular 
                                        text="Get 10% off your first Order!" 
                                        color="white"
                                    />
                                </Box>
                                
                                <Box
                                    component="img"
                                    src={ARROW_RIGHT}
                                    alt={"Arrow Right"}
                                    sx={{
                                        width: { xs: '20px', md: '24px' },
                                        height: 'auto',
                                        ml: { xs: 1, md: 2 }
                                    }}
                                />
                            </Button>
                        </Grid>


                        <Grid item container 
                            sx={{
                                marginTop:{xs:"80px"},
                                marginBottom:{xs:"40px"},
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                width: {
                                    xs: "100%",
                                    md: "400px"
                                },
                                marginLeft: {
                                    xs: "auto",
                                    md: "0"
                                },
                                marginRight: {
                                    xs: "auto",
                                    md: "0"
                                }
                            }}
                        >
                            <motion.div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 0,
                                    width: "100%"
                                }}
                            >
                                {/* Static Logo */}
                                <Box 
                                    component={'img'} 
                                    alt={'OSTRYX'} 
                                    src={OSTRYX_LOGO}
                                    sx={{
                                        width: {xs: "100px", md: "140px"}, 
                                        height: {xs: "100px", md: "140px"},
                                        zIndex: 2
                                    }}
                                />
                                
                                {/* Rotating Text */}
                                <motion.div
                                    style={{
                                        position: "absolute",
                                        width: isMobile ? "200px" : isTablet ? "240px" : "280px",
                                        height: isMobile ? "200px" : isTablet ? "240px" : "280px"
                                    }}
                                    animate={{ rotate: 360 }}
                                    transition={{
                                        duration: 15,
                                        repeat: Infinity,
                                        ease: "linear"
                                    }}
                                >
                                    <svg viewBox="0 0 400 400">
                                        <path
                                            id="circlePath"
                                            // d="M 200,200 m -180,0 a 180,180 0 1,1 360,0 a 180,180 0 1,1 -360,0"
                                            d="M 200,200 m -140,0 a 140,140 0 1,1 280,0 a 140,140 0 1,1 -280,0"
                                            fill="none"
                                        />
                                        <text>
                                            <textPath 
                                                href="#circlePath" 
                                                startOffset="0%"
                                                style={{ 
                                                    fill: "#5E17EB",
                                                    fontSize: isMobile ? "26px" : isTablet ? "26px" : "30px",
                                                    letterSpacing: isMobile ? "6px" : isTablet ? "6px" : "7px",
                                                }}
                                            >
                                                ✦ Quality  You  Can  Trust ✦  Innovation  You  Deserve     
                                            </textPath>
                                        </text>
                                    </svg>
                                </motion.div>
                            </motion.div>
                        </Grid>


                    </Grid>


                    <Grid 
                        item 
                        xs={12} 
                        md={5.5} 
                        container 
                        justifyContent={{xs:"center",md:"flex-end"}} 
                        sx={{
                            marginTop:{xs:"180px",md:"20px"},
                            marginBottom:{xs:"120px",md:"0"},
                            padding: { xs: "0 10px", md: "0" },
                            height: {sm:"250px",md:"100%"}
                        }}
                    >
                        <Grid item sx={{ 
                            width: "100%",
                            height: "100%",
                            position: "relative",
                            borderRadius: "20px",
                        }}>
                            {/* <Box
                                component="video"
                                autoPlay
                                muted
                                loop
                                playsInline
                                zIndex={-2}
                                sx={{
                                    width: "100%",
                                    height: "500px",
                                    borderRadius: "20px",
                                    top: {
                                        xs: "25%",
                                        sm: "25%",
                                        md: "35%"
                                    },
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    position: "absolute",
                                    objectFit: {
                                        xs: "contain",
                                        sm: "contain",
                                        md: "contain",
                                        lg: "fill"
                                    }
                                }}
                            >
                                <source src={OSTRYX_PROMO} type="video/mp4" alt={"OSTRYX Promo"}/>
                                Your browser does not support the video tag.
                            </Box> */}
                            <Box
                                sx={{
                                    borderRadius: "20px",
                                    width: "100%",
                                    height: {
                                        xs: "300px",  // Smaller height for mobile
                                        sm: "400px",  // Medium height for tablets
                                        md: "500px"   // Full height for desktop
                                    },
                                    top: {
                                        xs: "25%",
                                        sm: "25%",
                                        md: "35%"
                                    },
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    position: "absolute",
                                    overflow: "hidden",
                                    maxWidth: {
                                        xs: "100%",    // Slightly smaller width on mobile
                                        sm: "100%",    // Medium width for tablets
                                        md: "100%"    // Full width for desktop
                                    }
                                }}
                            >
                                <PromoVideo />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </div>





        </Grid>
        </ThemeProvider>
    )
}

export default Intro;
